import {useMemo} from 'react';
import {useProfile} from '../../Providers/ProfileProvider';

export const useDrawerEnabled = () => {
  const {profile} = useProfile();
  const {universalHelpDrawerEnabled, enableUniversalHelp} =
    profile.featureFlags;

  return useMemo(
    () => enableUniversalHelp && universalHelpDrawerEnabled,
    [enableUniversalHelp, universalHelpDrawerEnabled],
  );
};
